// Configure webpack's RUNTIME public path so dynamically-imported chunks
// (the React.lazy route bundles — `auth`, `admin`, `compare`, …) are
// fetched from the same reverse-proxy sub-path the app is mounted at
// (e.g. orbital-laser.com/land-ai/) instead of the root the bundle was
// built for.
//
// Background: the app is built with NO `homepage`/`PUBLIC_URL`, so webpack
// defaults its public path to "/". The orbital-laser nginx rewrites the
// served index.html's *static* asset refs to add the `/land-ai` prefix, so
// the EAGER main bundle loads fine. But code-split chunks are fetched at
// runtime via `__webpack_require__.p` (webpack's public path), which stays
// "/" — so `import()` requested `/static/js/auth.<hash>.chunk.js` (root)
// instead of `/land-ai/static/js/auth.<hash>.chunk.js`, 404'd, and stranded
// the login redirect in a reload loop. Regression #953 (from #944, which
// added the lazy `/login` route behind an app-wide auth gate).
//
// Setting `__webpack_public_path__` at runtime is the canonical CRA fix for
// a sub-path deploy with no build-time prefix. This module MUST be imported
// FIRST in index.js — before App and before any module that can trigger a
// dynamic import — so the public path is set before the first chunk fetch.
import { getBasePath } from './basePath';

// getBasePath() -> "/land-ai" under a sub-path, "" at a root deploy.
// webpack's chunk filenames are relative ("static/js/x.chunk.js"), so the
// public path needs a trailing slash: "/land-ai/" or "/".
export function resolvePublicPath() {
  return `${getBasePath() || ''}/`;
}

try {
  // webpack rewrites this assignment to `__webpack_require__.p = ...` at
  // build time. At a root deploy the value is "/", which is already the
  // default — so this is a no-op there and never regresses local dev.
  // eslint-disable-next-line no-undef, camelcase
  __webpack_public_path__ = resolvePublicPath();
} catch (e) {
  // Non-webpack runtime (Jest/babel): `__webpack_public_path__` is an
  // undeclared identifier, so the assignment throws in strict mode. There
  // is no webpack chunk loader to configure under Jest, so swallow it.
}
